// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import { Navigate } from "react-router-dom";

function BlogPage() {
    return <Navigate to="/blog" replace />;
}

export default BlogPage;